import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { SideBarData } from '../datafiles/SideBarData';
import SocIcons from './SocIcons';

const SideBar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(true);
  const [isLoaded, setIsLoaded] = useState(false);
  const navRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 1024;
      setIsMobile(mobile);
      setIsOpen(!mobile);
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    // Use requestAnimationFrame to ensure DOM has been painted
    requestAnimationFrame(() => {
      setIsLoaded(true);
      if (navRef.current) {
        navRef.current.style.transition = 'all 0.3s ease-in-out';
      }
    });

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      {isLoaded && (
        <button
          onClick={toggleSidebar}
          className={`fixed top-4 left-4 z-50 p-2 bg-white border border-black rounded transition-all duration-300 lg:hidden
            ${isOpen ? 'left-[calc(100%-3rem)]' : ''}`}
        >
          {isOpen ? '✕' : '☰'}
        </button>
      )}
      <nav 
        ref={navRef}
        className={`nav-menu bg-white flex flex-col justify-between fixed border-r border-black
          h-screen w-full lg:w-64 ${isOpen || !isMobile ? 'left-0' : '-left-full'} z-40`}
        style={{
          transition: isLoaded ? undefined : 'none',
          left: !isLoaded ? '-100%' : undefined
        }}
      >
        <ul className='list-none p-0 m-0 flex flex-col justify-center items-center h-full font-suwannaphum text-xl lg:text-2xl'>
          {SideBarData.map((item, index) => (
            <li key={index} className='mb-8 lg:mb-12'>
              <Link
                to={item.path}
                className='text-black hover:font-semibold relative group'
                onClick={() => isMobile && setIsOpen(false)}
              >
                {item.title}
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-black transition-all group-hover:w-full duration-300 ease-out"></span>
              </Link>
            </li>
          ))}
        </ul>
        <div className="pb-8">
          <SocIcons />
        </div>
      </nav>
    </>
  );
}

export default SideBar;